"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeBranch = exports.normalizeBranches = void 0;
const eval_1 = require("@tencent/data-schema-core/lib/utils/eval");
const lodash_1 = require("lodash");
/**
 * 用于应对 NodeMeta 里 branches 描述的数据不规整的问题。
 *
 * 输入 NodeMeta 和插值上下文，返回规整的 `NodeBranch[]`。返回的数组，长度 >= 1
 */
function normalizeBranches(nodeMeta, interopContext) {
    if (nodeMeta.branchesDisabled)
        return [];
    let rb = nodeMeta.branches;
    if ((0, eval_1.isExprObject)(rb))
        rb = (0, eval_1.tryEvalExpr)(rb.$expr, null, { state: {}, params: {}, ...interopContext });
    if (Array.isArray(rb) && rb.length) {
        const branches = (0, lodash_1.uniqBy)([...rb], 'id');
        return branches.map(b => normalizeBranch(b, branches.length));
    }
    return [{
            id: 'default',
            name: '下一步',
            position: 'bottom',
            nameHidden: true,
        }];
}
exports.normalizeBranches = normalizeBranches;
/**
 * 用于应对 NodeMeta 里 branches 描述的数据不规整的问题。
 *
 * 输入一个 NodeBranch 声明，返回一个补全了信息（比如 name 等可选字段）的 NodeBranch
 */
function normalizeBranch(branch, branchCount = 1) {
    var _a, _b;
    const b = typeof branch === 'string' ? { id: branch } : branch;
    const id = String(b.id);
    return {
        id,
        name: String(b.name || ((b.name === 'default' && branchCount <= 1) ? '下一步' : id)),
        position: (_a = b.position) !== null && _a !== void 0 ? _a : 'bottom',
        nameHidden: (_b = b.nameHidden) !== null && _b !== void 0 ? _b : false,
    };
}
exports.normalizeBranch = normalizeBranch;
//# sourceMappingURL=nodeMeta.js.map